import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { ApiErrors } from '../../enums';
const isPinValidationError = (error) => {
    const errorObj = error;
    return errorObj?.result?.error === ApiErrors.PIN_FAILURE_TO_VALIDATE;
};
export function usePinModal(props) {
    const { onConfirm } = props;
    const { t } = useTranslation();
    const [showPinModal, setShowPinModal] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [showPinError, setShowPinError] = useState(false);
    const [pinErrorMessage, setPinErrorMessage] = useState('');
    const openPinModal = useCallback(() => {
        setShowPinModal(true);
        setShowPinError(false);
        setPinErrorMessage('');
    }, []);
    const handlePinConfirm = useCallback(async (pin) => {
        setIsCreating(true);
        setShowPinError(false);
        try {
            await onConfirm(pin);
            setShowPinModal(false);
        }
        catch (error) {
            if (isPinValidationError(error)) {
                setShowPinError(true);
                setPinErrorMessage(t('pix-keys.pin-incorrect-error'));
            }
            else {
                setShowPinModal(false);
                throw error;
            }
        }
        finally {
            setIsCreating(false);
        }
    }, [onConfirm, t]);
    const handlePinCancel = useCallback(() => {
        setShowPinModal(false);
        setShowPinError(false);
        setPinErrorMessage('');
    }, []);
    const handlePinClose = useCallback(() => {
        setShowPinModal(false);
        setShowPinError(false);
        setPinErrorMessage('');
    }, []);
    const handlePinErrorClose = useCallback(() => {
        setShowPinError(false);
        setPinErrorMessage('');
    }, []);
    return {
        showPinModal,
        isCreating,
        showPinError,
        pinErrorMessage,
        handlePinConfirm,
        handlePinCancel,
        handlePinClose,
        handlePinErrorClose,
        openPinModal,
    };
}
